import Mousetrap from "mousetrap";
import { useEffect } from "react";

export default function useSearchKeybind(open) {
    useEffect(
        () => {
            const mousetrap = Mousetrap();

            mousetrap.bind("/", open, "keyup");

            for (const letter of "abcdefghijklmnopqrstuvwxyz0123456789") {
                mousetrap.bind(letter, open, "keydown");
            }

            return () => mousetrap.reset();
        },
        [],
    );
}
